// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import {
//   Alert,
//   Box,
//   CircularProgress,
//   IconButton,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { RootState } from 'app/store';
// import React, { useEffect, useRef, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { AnyAction } from 'redux';
// import { ThunkDispatch } from 'redux-thunk';
// import { fetchWorkloadInvoice } from 'slices/NdisSlices/finance/InvoiceSlice';
// import { Invoice } from 'types/ndisSection/invoiceTypes';

// interface WorkloadReportProps {
//   invoice: Invoice;
//   onEdit: (invoice: Invoice) => void;
//   onBack: () => void;
//   isSmallScreen: boolean;
//   fortnightDate: string;
// }

// interface WorkloadEntry {
//   Staff_name: string;
//   worked_hours: number;
//   Planned_Hours: number;
//   support_item_name: string;
// }

// interface TableInvoice {
//   id: string;
//   invoiceNumber: string;
//   customerName: string;
//   date: string;
//   totalHours: number;
//   totalAmount: number;
//   avatar?: string;
//   workLoad_Report?: Record<string, WorkloadEntry>;
// }

// const WorkloadReport: React.FC<WorkloadReportProps> = ({
//   invoice,
//   isSmallScreen,
//   fortnightDate,
//   onEdit,
//   onBack
// }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const dispatch = useDispatch<ThunkDispatch<RootState, unknown, AnyAction>>();
//   const componentRef = useRef<HTMLDivElement>(null);

//   const [localLoading, setLocalLoading] = useState(false);
//   const [localError, setLocalError] = useState<string | null>(null);

//   // Redux state
//   const { current_invoice } = useSelector(
//     (state: RootState) => state.invoice || { current_invoice: null }
//   );
//   const selectedProjectId = useSelector(
//     (state: RootState) => (state as any).homeTilesServices?.selectedProjectId || ''
//   );
//   const selectedServiceTitle = useSelector(
//     (state: RootState) => state.serviceSelected.selectedServiceTitle || ''
//   );
//   const parsedUserDetails = JSON.parse(localStorage.getItem('user-details') || '{}');

//   useEffect(() => {
//     if (!invoice.invoice_number) {
//       console.error('Invoice number is missing');
//       setLocalError('Invoice number is missing');
//       return;
//     }

//     console.log('fetchWorkloadInvoice', invoice);

//     const filterDate = fortnightDate
//       ? new Date(fortnightDate.split(' - ')[0].split(': ')[1].split('/').reverse().join('-'))
//           .toISOString()
//           .split('T')[0]
//       : new Date().toISOString().split('T')[0];

//     const payload = {
//       user_whoRequested_id: parsedUserDetails.name || '',
//       group_id: selectedProjectId || '',
//       service_name_id: (selectedServiceTitle || '').replace(' ', '_'),
//       nested_component_id: 'Invoice',
//       invoice_id: invoice.invoice_number,
//       client_name: invoice.customer_name || '',
//       client_key: invoice.client_key || '',
//       filter_date: filterDate
//     };

//     const fetchData = async () => {
//       setLocalLoading(true);
//       setLocalError(null);
//       try {
//         await dispatch(fetchWorkloadInvoice(payload)).unwrap();
//       } catch (error: any) {
//         setLocalError(error.message || 'Failed to fetch workload invoice data');
//       } finally {
//         setLocalLoading(false);
//       }
//     };

//     fetchData();
//   }, [
//     dispatch,
//     invoice.invoice_number,
//     invoice.customer_name,
//     parsedUserDetails.name,
//     selectedProjectId,
//     selectedServiceTitle,
//     fortnightDate
//   ]);

//   const selectedInvoice = Array.isArray(current_invoice)
//     ? current_invoice.find((inv: Invoice) => inv.invoice_number === invoice.invoice_number) || null
//     : current_invoice;

//   const displayInvoice: TableInvoice = selectedInvoice
//     ? {
//         id: selectedInvoice.id || selectedInvoice.invoice_number || `temp-${Math.random()}`,
//         invoiceNumber: selectedInvoice.invoice_number || 'N/A',
//         customerName: selectedInvoice.customer_name || 'Unknown',
//         date: selectedInvoice.issued_date || '',
//         totalHours: selectedInvoice.summary?.total_hours || 0,
//         totalAmount: selectedInvoice.summary?.total_amount_due || 0,
//         avatar: selectedInvoice.avatar,
//         workLoad_Report: selectedInvoice.workLoad_Report || {}
//       }
//     : {
//         id: invoice.id || invoice.invoice_number || `temp-${Math.random()}`,
//         invoiceNumber: invoice.invoice_number || 'N/A',
//         customerName: invoice.customer_name || 'Unknown',
//         date: invoice.issued_date || '',
//         totalHours: invoice.summary?.total_hours || 0,
//         totalAmount: invoice.summary?.total_amount_due || 0,
//         avatar: invoice.avatar,
//         workLoad_Report: invoice.workLoad_Report || {}
//       };

//   const getWorkloadStatus = (workedHours: number, plannedHours: number) => {
//     if (plannedHours === 0) return 'Invalid';
//     const percentage = (workedHours / plannedHours) * 100;
//     if (percentage < 80) return 'Underworked';
//     if (percentage > 120) return 'Overworked';
//     return 'On Track';
//   };

//   const getStatusColor = (status: string) => {
//     switch (status) {
//       case 'Underworked':
//         return theme.palette.warning.main;
//       case 'Overworked':
//         return theme.palette.error.main;
//       case 'Invalid':
//         return theme.palette.grey[500];
//       default:
//         return theme.palette.success.main;
//     }
//   };

//   const formatHours = (hours: number) => {
//     // Format to use comma as decimal separator if needed
//     return hours.toFixed(2).replace('.', ',');
//   };

//   console.log('displayInvoice', displayInvoice);

//   return (
//     <Box
//       ref={componentRef}
//       sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         flexGrow: 1,
//         overflow: 'hidden',
//         p: isMobile ? 0.5 : 1,
//         height: '100%',
//         backgroundColor: theme.palette.background.paper
//       }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           mb: 1,
//           p: 1,
//           backgroundColor: theme.palette.primary.light,
//           color: theme.palette.primary.contrastText,
//           borderRadius: 1
//         }}
//       >
//         <IconButton onClick={onBack} size="small" sx={{ mr: 1 }}>
//           <ArrowBackIcon fontSize="small" />
//         </IconButton>
//         <Typography
//           variant={isMobile ? 'subtitle2' : 'subtitle1'}
//           sx={{
//             fontWeight: 600,
//             flexGrow: 1
//           }}
//         >
//           Workload Report
//         </Typography>
//       </Box>

//       {localLoading ? (
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             height: '100%',
//             p: 4
//           }}
//         >
//           <CircularProgress size={isMobile ? 24 : 32} />
//         </Box>
//       ) : localError ? (
//         <Alert severity="error" sx={{ mb: 2 }}>
//           {localError}
//         </Alert>
//       ) : displayInvoice.workLoad_Report &&
//         Object.keys(displayInvoice.workLoad_Report).length > 0 ? (
//         <Box
//           sx={{
//             flexGrow: 1,
//             overflow: 'auto'
//           }}
//         >
//           <TableContainer
//             component={Paper}
//             sx={{
//               width: '100%',
//               maxHeight: 'calc(100vh - 120px)',
//               overflow: 'auto',
//               boxShadow: 'none',
//               border: `1px solid ${theme.palette.divider}`
//             }}
//           >
//             <Table
//               size="small"
//               sx={{
//                 '& .MuiTableCell-root': {
//                   py: isMobile ? 0.5 : 1,
//                   px: isMobile ? 0.5 : 1.5,
//                   fontSize: isMobile ? '0.75rem' : '0.875rem',
//                   borderRight: `1px solid ${theme.palette.divider}`,
//                   '&:last-child': {
//                     borderRight: 'none'
//                   }
//                 },
//                 '& .MuiTableHead-root .MuiTableCell-root': {
//                   fontWeight: 600,
//                   fontSize: isMobile ? '0.55rem' : '0.8rem',
//                   backgroundColor: theme.palette.grey[100],
//                   textTransform: 'uppercase',
//                   letterSpacing: '0.03em'
//                 }
//               }}
//             >
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Staff Name</TableCell>
//                   <TableCell align="right">Worked Hours</TableCell>
//                   <TableCell align="right">Planned Hours</TableCell>
//                   <TableCell align="center">Status</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {Object.entries(displayInvoice.workLoad_Report).map(([key, worker]) => {
//                   const status = getWorkloadStatus(worker.worked_hours, worker.Planned_Hours);
//                   return (
//                     <TableRow
//                       key={key}
//                       sx={{
//                         '&:nth-of-type(odd)': {
//                           backgroundColor: theme.palette.action.hover
//                         }
//                       }}
//                     >
//                       <TableCell
//                         sx={{
//                           maxWidth: isMobile ? '80px' : 'none',
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis'
//                         }}
//                       >
//                         {worker.Staff_name}
//                       </TableCell>
//                       <TableCell align="right">{worker.worked_hours}</TableCell>
//                       <TableCell align="right">{worker.Planned_Hours}</TableCell>
//                       {/* <TableCell align="right">{formatHours(worker.worked_hours)}</TableCell>
//                       <TableCell align="right">{formatHours(worker.Planned_Hours)}</TableCell> */}
//                       <TableCell align="center">
//                         <Box
//                           sx={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center'
//                           }}
//                         >
//                           <Box
//                             sx={{
//                               width: 8,
//                               height: 8,
//                               borderRadius: '50%',
//                               bgcolor: getStatusColor(status),
//                               mr: 1
//                             }}
//                           />
//                           <Typography
//                             variant="caption"
//                             sx={{
//                               color: getStatusColor(status),
//                               fontWeight: 500,
//                               fontSize: isMobile ? '0.7rem' : '0.75rem'
//                             }}
//                           >
//                             {status}
//                           </Typography>
//                         </Box>
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Box>
//       ) : (
//         <Alert severity="info" sx={{ mb: 2 }}>
//           No workload report data available for this invoice.
//         </Alert>
//       )}
//     </Box>
//   );
// };

// export default WorkloadReport;

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  Alert,
  Box,
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { RootState } from 'app/store';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { fetchWorkloadInvoice } from 'slices/NdisSlices/finance/InvoiceSlice';
import { Invoice } from 'types/ndisSection/invoiceTypes';

interface WorkloadReportProps {
  invoice: Invoice;
  onEdit: (invoice: Invoice) => void;
  onBack: () => void;
  isSmallScreen: boolean;
  fortnightDate: string;
}

interface WorkloadEntry {
  Staff_name: string;
  worked_hours: number;
  Planned_Hours: number;
  support_item_name: string;
  date_key: string;
}

interface TableInvoice {
  id: string;
  invoiceNumber: string;
  customerName: string;
  date: string;
  totalHours: number;
  totalAmount: number;
  avatar?: string;
  workLoad_Report?: Record<string, Record<string, WorkloadEntry>>;
}

const WorkloadReport: React.FC<WorkloadReportProps> = ({
  invoice,
  isSmallScreen,
  fortnightDate,
  onEdit,
  onBack
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch<ThunkDispatch<RootState, unknown, AnyAction>>();
  const componentRef = useRef<HTMLDivElement>(null);

  const [localLoading, setLocalLoading] = useState(false);
  const [localError, setLocalError] = useState<string | null>(null);

  // Redux state
  const { current_invoice } = useSelector(
    (state: RootState) => state.invoice || { current_invoice: null }
  );
  const selectedProjectId = useSelector(
    (state: RootState) => (state as any).homeTilesServices?.selectedProjectId || ''
  );
  const selectedServiceTitle = useSelector(
    (state: RootState) => state.serviceSelected.selectedServiceTitle || ''
  );
  const parsedUserDetails = JSON.parse(localStorage.getItem('user-details') || '{}');

  useEffect(() => {
    if (!invoice.invoice_number) {
      console.error('Invoice number is missing');
      setLocalError('Invoice number is missing');
      return;
    }

    const filterDate = fortnightDate
      ? new Date(fortnightDate.split(' - ')[0].split(': ')[1].split('/').reverse().join('-'))
          .toISOString()
          .split('T')[0]
      : new Date().toISOString().split('T')[0];

    const payload = {
      user_whoRequested_id: parsedUserDetails.name || '',
      group_id: selectedProjectId || '',
      service_name_id: (selectedServiceTitle || '').replace(' ', '_'),
      nested_component_id: 'Invoice',
      invoice_id: invoice.invoice_number,
      client_name: invoice.customer_name || '',
      client_key: invoice.client_key || '',
      filter_date: filterDate
    };

    const fetchData = async () => {
      setLocalLoading(true);
      setLocalError(null);
      try {
        await dispatch(fetchWorkloadInvoice(payload)).unwrap();
      } catch (error: any) {
        setLocalError(error.message || 'Failed to fetch workload invoice data');
      } finally {
        setLocalLoading(false);
      }
    };

    fetchData();
  }, [
    dispatch,
    invoice.invoice_number,
    invoice.customer_name,
    parsedUserDetails.name,
    selectedProjectId,
    selectedServiceTitle,
    fortnightDate
  ]);

  const selectedInvoice = Array.isArray(current_invoice)
    ? current_invoice.find((inv: Invoice) => inv.invoice_number === invoice.invoice_number) || null
    : current_invoice;

  const displayInvoice: TableInvoice = selectedInvoice
    ? {
        id: selectedInvoice.id || selectedInvoice.invoice_number || `temp-${Math.random()}`,
        invoiceNumber: selectedInvoice.invoice_number || 'N/A',
        customerName: selectedInvoice.customer_name || 'Unknown',
        date: selectedInvoice.issued_date || '',
        totalHours: selectedInvoice.summary?.total_hours || 0,
        totalAmount: selectedInvoice.summary?.total_amount_due || 0,
        avatar: selectedInvoice.avatar,
        workLoad_Report: selectedInvoice.workLoad_Report || {}
      }
    : {
        id: invoice.id || invoice.invoice_number || `temp-${Math.random()}`,
        invoiceNumber: invoice.invoice_number || 'N/A',
        customerName: invoice.customer_name || 'Unknown',
        date: invoice.issued_date || '',
        totalHours: invoice.summary?.total_hours || 0,
        totalAmount: invoice.summary?.total_amount_due || 0,
        avatar: invoice.avatar,
        workLoad_Report: invoice.workLoad_Report || {}
      };

  // Flatten workLoad_Report to get all worker entries
  const workloadEntries: WorkloadEntry[] = [];
  if (displayInvoice.workLoad_Report) {
    Object.entries(displayInvoice.workLoad_Report).forEach(([dateKey, workers]) => {
      Object.entries(workers).forEach(([workerKey, worker]) => {
        workloadEntries.push({
          ...worker,
          date_key: dateKey // Optional: include date_key if needed for display
        });
      });
    });
  }

  const getWorkloadStatus = (workedHours: number, plannedHours: number) => {
    if (plannedHours === 0) return 'Invalid';
    const percentage = (workedHours / plannedHours) * 100;
    if (percentage < 80) return 'Underworked';
    if (percentage > 120) return 'Overworked';
    return 'On Track';
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Underworked':
        return theme.palette.warning.main;
      case 'Overworked':
        return theme.palette.error.main;
      case 'Invalid':
        return theme.palette.grey[500];
      default:
        return theme.palette.success.main;
    }
  };

 const formatHours = (hours: number) => {
   return Math.ceil(hours).toString();
 };


  return (
    <Box
      ref={componentRef}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        overflow: 'hidden',
        p: isMobile ? 0.5 : 1,
        height: '100%',
        backgroundColor: theme.palette.background.paper
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 1,
          p: 1,
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.contrastText,
          borderRadius: 1
        }}
      >
        <IconButton onClick={onBack} size="small" sx={{ mr: 1 }}>
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <Typography
          variant={isMobile ? 'subtitle2' : 'subtitle1'}
          sx={{
            fontWeight: 600,
            flexGrow: 1
          }}
        >
          Workload Report
        </Typography>
      </Box>

      {localLoading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            p: 4
          }}
        >
          <CircularProgress size={isMobile ? 24 : 32} />
        </Box>
      ) : localError ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {localError}
        </Alert>
      ) : workloadEntries.length > 0 ? (
        <Box
          sx={{
            flexGrow: 1,
            overflow: 'auto'
          }}
        >
          <TableContainer
            component={Paper}
            sx={{
              width: '100%',
              maxHeight: 'calc(100vh - 120px)',
              overflow: 'auto',
              boxShadow: 'none',
              border: `1px solid ${theme.palette.divider}`
            }}
          >
            <Table
              size="small"
              sx={{
                '& .MuiTableCell-root': {
                  py: isMobile ? 0.5 : 1,
                  px: isMobile ? 0.5 : 1.5,
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  borderRight: `1px solid ${theme.palette.divider}`,
                  '&:last-child': {
                    borderRight: 'none'
                  }
                },
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 600,
                  fontSize: isMobile ? '0.55rem' : '0.8rem',
                  backgroundColor: theme.palette.grey[100],
                  textTransform: 'uppercase',
                  letterSpacing: '0.03em'
                }
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>Staff Name</TableCell>
                  <TableCell align="right">Worked Hours</TableCell>
                  <TableCell align="right">Planned Hours</TableCell>
                  <TableCell align="center">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {workloadEntries.map((worker, index) => {
                  const status = getWorkloadStatus(worker.worked_hours, worker.Planned_Hours);
                  return (
                    <TableRow
                      key={`${worker.date_key}-${worker.Staff_name}-${index}`}
                      sx={{
                        '&:nth-of-type(odd)': {
                          backgroundColor: theme.palette.action.hover
                        }
                      }}
                    >
                      <TableCell
                        sx={{
                          maxWidth: isMobile ? '80px' : 'none',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}
                      >
                        {worker.Staff_name}
                      </TableCell>
                      <TableCell align="right">{formatHours(worker.worked_hours)}</TableCell>
                      <TableCell align="right">{formatHours(worker.Planned_Hours)}</TableCell>
                      <TableCell align="center">
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <Box
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: '50%',
                              bgcolor: getStatusColor(status),
                              mr: 1
                            }}
                          />
                          <Typography
                            variant="caption"
                            sx={{
                              color: getStatusColor(status),
                              fontWeight: 500,
                              fontSize: isMobile ? '0.7rem' : '0.75rem'
                            }}
                          >
                            {status}
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <Alert severity="info" sx={{ mb: 2 }}>
          No workload report data available for this invoice.
        </Alert>
      )}
    </Box>
  );
};

export default WorkloadReport;
